import {PlayCountryNames} from "play-country-names/dist/scripts/playCountryNames";
import * as angular from "angular";
import {forEach, find, orderBy} from "lodash";


export class RegionFilterController {
    public app: any;
    public participants: any[];
    public filtering: any;
    public regions: any[];
    public showRegionList = false;

    public static $inject = ["$scope"];
    constructor(
        private $scope: angular.IScope
    ) {
    }

    public $onInit() {
        const body = angular.element(document).find("body");
        body.on("keydown keypress", this.closeRegionList.bind(this));
        body.on("click", this.closeRegionList.bind(this));
    }

    public $onDestroy() {
        const body = angular.element(document).find("body");
        body.off("keydown keypress", this.closeRegionList.bind(this));
        body.off("click", this.closeRegionList.bind(this));
    }

    public $onChanges(changesObj) {
        if (this.participants && changesObj.participants) {
            this.regions = [];

            forEach(this.participants, (participant: any) => {
                let currentRegion = participant.region;
                let regionInRegions = find(this.regions, (region: any) => {
                    return region.countryCode === currentRegion;
                });

                if (regionInRegions) {
                    regionInRegions.count++;
                } else {
                    this.regions.push({
                        name: this.getRegionName(currentRegion),
                        countryCode: currentRegion,
                        count: 1
                    });
                }
            });

            // Add "all" Region.
            this.regions.push({
                name: "All",
                countryCode: undefined,
                count: this.participants.length
            });

            this.regions = orderBy(this.regions, ["count", "name"], ["desc", "asc"]);
        }
    }

    /**
     * Set a filter by region.
     * @param region The only region to show as a country code, e.g. FR, DE or PL.
     */
    public setRegionFilter(region: string) {
        if (region === null) {
            region = "null";
        }

        this.app.filterByRegion(region);
    }

    /**
     * Toggle display of the region dropdown.
     * @param event Optional. Provide to explicitly set true/false.
     */
    public toggleRegionList(event) {
        event.stopPropagation();
        this.showRegionList = !this.showRegionList;
    }

    /**
     * Close the region list by event.
     * @param event The event.
     */
    private closeRegionList(event: any) {
        if (event.which === 1 || event.which === 27) { // 27 == esc key
            this.showRegionList = false;
            this.$scope.$apply();
        }
    }

    /**
     * Get the region name of a country code.
     * @param code The esl region/country code (DE, GB, etc.).
     */
    public getRegionName(code: string) {
        return PlayCountryNames.get(code);
    }
}